import { baseApiHeaders, HIDE_TOAST_KEY, type IApiResponse, type IUser, type OTPTYPE } from 'BreetHelpers';

import { apiSlice } from './apiSlice';

export const authApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<
			IApiResponse<IUser>,
			{ email: string; password?: string; otp?: string | { code?: string; type?: OTPTYPE } }
		>({
			query: (body) => ({
				method: 'POST',
				url: '/auth/login/vip',
				body,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
		}),
		logout: builder.mutation<IApiResponse, void>({
			query: () => ({
				method: 'DELETE',
				url: '/auth/logout/user',
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
		}),
		forgotPassword: builder.mutation<IApiResponse<{ token: string }>, { email: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/auth/forgot-password',
				body,
			}),
		}),
		resendVerification: builder.mutation<IApiResponse, { email: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/auth/verification',
				body,
			}),
		}),
		verifyOTPAuth: builder.mutation<IApiResponse, { token: string; otp: string }>({
			query: (body) => ({
				method: 'PUT',
				url: '/auth/verify-otp',
				body,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
		}),
		verifyPassword: builder.mutation<IApiResponse, { password: string }>({
			query: (body) => ({
				method: 'PUT',
				url: '/users/user/password',
				body,
			}),
		}),
		changePassword: builder.mutation<IApiResponse, { newPassword: string; oldPassword: string }>({
			query: (body) => ({
				method: 'PATCH',
				url: '/users/user/password',
				body,
			}),
		}),
		resetPassword: builder.mutation<IApiResponse, { token: string; password: string }>({
			query: (body) => ({
				method: 'PUT',
				url: '/auth/reset-password',
				body,
			}),
		}),
	}),
});

export const {
	useForgotPasswordMutation,
	useVerifyOTPAuthMutation,
	useResetPasswordMutation,
	useResendVerificationMutation,
	useLoginMutation,
	useVerifyPasswordMutation,
	useLogoutMutation,
	useChangePasswordMutation,
} = authApiSlice;
